<div class="p-5">
   <div [innerHTML]="data" class="text-center"></div>
</div>
